import { useEffect } from "react"
import useAuth, { useAuthUpdater } from "./client-auth"

export function GoogleOneTap() {
	const { userInfo } = useAuth()
	const { logInWithCredential } = useAuthUpdater()

	useEffect(() => {
		if (userInfo) {
			return
		}

		try {
			if (!window.google || !window.google.accounts) {
				return
			}

			window.google.accounts.id.initialize({
				client_id:
					"812897686182-j19gl2hne56500v0clhd62h22p11fspj.apps.googleusercontent.com",
				callback: async (response) => {
					try {
						await logInWithCredential(response.credential)
					} catch (error) {
						console.error(
							"Error logging in with credential",
							error,
						)
					}
				},
			})

			window.google.accounts.id.prompt()
		} catch (e) {
			console.error("Google One Tap Error", e)
		}
	}, [logInWithCredential, userInfo])

	return (
		<script
			src="https://accounts.google.com/gsi/client"
			async
			defer
		/>
	)
}
